import { param } from 'jquery';
import { VclSnackBarService } from '@voxel/community';
import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ComponentRef, Injectable, Input, OnInit } from '@angular/core';
import { CatalogService } from './../../shared/services/catalogs/catalog.service';
import { ControlContainer, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CopyService } from './../../shared/services/copies/copy.service';
import { ValidatorFormFieldService, ValidatorsPatterns } from '../../shared/services/forms/validator-form-field.service';
import { memoize, getValueProperty as getValue, getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { ApplicationService } from '../../shared/services/application/application.service';
import { BaseComponent } from '../../shared/components/base-component';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { EVENT } from '../../shared/constants/dali.constants';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';

export enum EFormMoldalActions {
  UPDATE = 'update',
  CREATE = 'create',
  DELETE = 'delete'
}

@Component({
  selector: 'app-form-solicitation-contacts-data',
  templateUrl: './form-solicitation-contacts-data.component.html',
  styleUrls: ['./form-solicitation-contacts-data.component.scss'],
})
export class FormSolicitationContactsDataComponent extends BaseComponent implements OnInit {
  form: FormGroup = this.fb.group({});
  CONTENT_BOUNDS: any[] | any;

  @Input()
  data: any;
  @Input()
  _settings: any;

  /**
   * Migracion
   */
  displayedColumns: string[] = [
    'Nombre',
    'Telefono1',
    //'Telefono2', 
    'Departamento',
    'Ciudad',
    'Correo',
    'Opcion'
  ];
  modalAShow = false;
  modalBShow = false;
  allowAddContact = true;

  idx: number = 0;
  settingdefdata: any;
  modalCaption?: string;
  public _nameLength: any = undefined;
  _errs: Array<any> = [];
  _selectErr: any;
  _selectInit: any;

  accordionGroupExpandOne: boolean = true;

  public get nameLength(): any {
    let res = undefined;
    let asn = async () => await Promise.resolve(this.cps.getCopy("form-solicitation-contacts-data")).then((data: any) => { res = getValueProperty(data, "nameLength"); return res; });
    return this._nameLength ?? asn();
  }
  public set nameLength(value: any) {
    this._nameLength = value;
  }

  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private cps: CopyService,
    private controlContainer: ControlContainer,
    public validatorFormField: ValidatorFormFieldService,
    public readonly app: ApplicationService,
    private link: LinkupService,
    private readonly vclSnackBarService: VclSnackBarService,
    public requestSolicitation: RequestSolicitationsService
  ) {
    super(app, link, 'form-solicitation-contacts-data');
  }


  ngOnInit(): void {
    this.isLoading = true;
    this.loadStaticValues()
      .then(async () => {
        await this.initControls()
        await this.loadData();
        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      }).catch((err) => {
        this.isLoading = false;
      });
  }

  /**
   * Permite inicializar los campos del formulario en el componente
   */
  async initControls() {
    let form = <FormGroup>this.controlContainer.control;
    if (form) {
      this.form = form;
    }

    const PATTERN_PLAIN_TEXT = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PLAIN_TEXT);
    const PATTERN_PHONE = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PHONE);
    const NAME_LENGTH = await this.nameLength;

    this.settingdefdata = await this.link.settings;

    const contactPrimaryGroup = this.fb.group({
      names: this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAME_LENGTH)]),
      surnames: this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAME_LENGTH)]),
      phone_1: this.fb.control('', [Validators.required, Validators.pattern(PATTERN_PHONE)]),
      email: this.fb.control('', [Validators.required, Validators.email]),
      contact_exist: this.fb.control(false, []),
    });

    const contactAdditionalGroup = this.fb.group({
      names: this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAME_LENGTH)]),
      surnames: this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT), Validators.maxLength(NAME_LENGTH)]),
      phone_1: this.fb.control('', [Validators.pattern(PATTERN_PHONE)]),
      email: this.fb.control('', [Validators.email]),
      contact_exist: this.fb.control(false, []),
    });

    this.form.addControl("contact_primary", contactPrimaryGroup);
    this.form.addControl("contact_additional", contactAdditionalGroup);

    this.form.setControl("CA_Names", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("CA_LastName", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("CA_Phone", this.fb.control('', [Validators.pattern(PATTERN_PHONE), Validators.minLength(7), Validators.maxLength(10)]));
    this.form.addControl("CA_Email", this.fb.control('', [Validators.email]));
    this.form.addControl("CA_Code", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("CA_CodeProduct", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("SA_Names", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("SA_LastName", this.fb.control('', [Validators.pattern(PATTERN_PLAIN_TEXT)]));
    this.form.addControl("SA_Phone", this.fb.control('', [Validators.pattern(PATTERN_PHONE)]));
    this.form.addControl("SA_Email", this.fb.control('', [Validators.email]));
    this.form.addControl("advisor_visible", this.fb.control(false, []));

    this.form.updateValueAndValidity();
  }

  /**
   * Permite la carga de textos y listas estaticas
   */
  async loadStaticValues() {
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy("form-solicitation-contacts-data");
    this._selectErr = getValueProperty(this.CONTENT_BOUNDS, "control_validations.selectErr");
    this._selectInit = getValueProperty(this.CONTENT_BOUNDS, "control_validations.selectInit");

    this.accordionGroupExpandOne = getValueProperty(this.CONTENT_BOUNDS, "accordionGroup.expandOne", true);

  }

  async loadData() {
    this.form.reset({
      advisor_visible: false
    });

    if (this.data) {

      const CONTACT_DATA = getValueProperty(this.data, 'contactsData', false);

      console.log('CONTACT_DATA', this.data);

      if (CONTACT_DATA) {
        let values = { ...CONTACT_DATA };
        this.form.patchValue(values);
        this.contactPrimary.markAllAsTouched();
        this.contactPrimary.markAsPristine();
        this.contactPrimary.updateValueAndValidity();
        
      }
      if (this.data.basicData) {

        /*const customerExists = getValueProperty(this.requestSolicitation, 'solicitation.basicData.customer_exists', false);
        const customerValidation = getValueProperty(this.requestSolicitation, 'solicitation.basicData.customer_validation', false);
        if ((!customerExists || customerValidation)) {
          const isNaturalPerson = getValueProperty(this.requestSolicitation, 'solicitation.basicData.isNaturalPerson', true);
          const NAME_LENGTH = await this.nameLength;
          let names = getValueProperty(this.requestSolicitation, 'solicitation.basicData.client_names', '');
          let surnames = getValueProperty(this.requestSolicitation, 'solicitation.basicData.client_surnames', '');
          let preloadData = {
            names: isNaturalPerson ? names.substring(0, NAME_LENGTH).trim() : null,
            surnames: isNaturalPerson ? surnames.substring(0, NAME_LENGTH).trim() : null,
            contact_exist: false 
          };
          this.contactPrimary.reset(preloadData);
          this.formContactModal.updateValueAndValidity();
        }*/



        let default_data = getValueProperty(
          this.settingdefdata,
          `request.OPERADOR_FIND.${this.app.currentApplication}.default_data`,
          {});
        if (getValueProperty(default_data, "basicData.document_type") == getValueProperty(this.data, "basicData.document_type") && getValueProperty(default_data, "basicData.document_number") == getValueProperty(this.data, "basicData.document_number")) {
          if (default_data.contactsData && default_data.contactsData.hasOwnProperty('contact')) {

            const CONTACT_PRIMARY = getValueProperty(default_data, 'contactsData.contact_primary');
            const CONTACT_ADDITIONAL = getValueProperty(default_data, 'contactsData.contact_additional');

            if (CONTACT_PRIMARY) {
              this.contactPrimary.patchValue(CONTACT_PRIMARY);
            }

            if (CONTACT_ADDITIONAL) {
              this.contactAdditional.patchValue(CONTACT_ADDITIONAL);
            }

          }
        }
      }
    }
  }

  /**
   *
   */
  get contactPrimary(): FormGroup {
    return this.form.get('contact_primary') as FormGroup;
  }

  get contactAdditional(): FormGroup {
    return this.form.get('contact_additional') as FormGroup;
  }

  /**
   * @todo Revisar funcionamiento
   */

  async openModal(name: string) {
    let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
        "name": "{EVENT.pv3E2setData.pv3E2transactionName.path}",
        "value": getValueProperty(EVENT, 'pv3E2setData.pv3E2transactionName.value')
      },
      {
        "name": "{EVENT.pv3E2setData.pv3E2transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ];
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
  }

  /**
   * Permite obtener los mensajes de error
   * @param control
   * @returns
   */
  @memoize()
  async getMessageError(form: FormGroup, control: { label: string, formControlName: string }, errors: any) {
    const { label, formControlName } = control;
    const formControl = form.get(formControlName);
    if (formControl) {
      return await this.validatorFormField.getMessageError(label, formControl, errors);
    } else {
      return '';
    }
  }

  /**
     * Permite obtener el valor de una propiedad del objeto pasado por parametro
     * @param object
     * @param property
     */
  getValueProperty(object: any, property: string | number) {
    return getValue(object, property);
  }

  get isNaturalPerson() {
    return getValueProperty(this.requestSolicitation, 'solicitation.basicData.isNaturalPerson', true);
  }

}
